import { render, staticRenderFns } from "./previewPhotoBox.vue?vue&type=template&id=9203def8&"
import script from "./previewPhotoBox.vue?vue&type=script&lang=js&"
export * from "./previewPhotoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports